export const statusMapper = ({
  status,
  canvas_status,
}: {
  status: string;
  canvas_status?: string;
}): string => {
  const formattedStatus = status.toLowerCase();

  if (canvas_status) return canvas_status;

  switch (formattedStatus) {
    case 'pending':
      return 'Not started';
    default:
      return status;
  }
};
